{
    "DarkMode_Switch_Title": "Donkere modus",
    "NAME": "DarkMode",
    "DarkMode_SwitchLight_Title": "Lichtmodus"
}